export function parseServiceErrors(errorResponse) {
  const parsedErrors = [];

  const details = errorResponse?.details || {};
  for (const [param, errors] of Object.entries(details)) {
    errors.forEach((err) => {
      parsedErrors.push({
        param,
        msg: err.message || "Unknown error",
      });
    });
  }

  return parsedErrors;
}
